import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';
import EvaluatorPaymentActionParamsItem from './EvaluatorPaymentActionParamsItem';

export default class VoidWindowDescription {
  static titleForCreate = 'Void';
  static titleForEdit = 'Void';
  static finishButtonLabel = 'Void';
  static itemType = EvaluatorPaymentActionParamsItem;
  static serviceFunction = (edited) => EvaluatorPaymentService.Void(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Void process has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [{ fieldName: 'Reason', label: 'Comment', className: 'col-12', type: InputTypesEnum.TextBox }],
    },
  ];
}
